import React from 'react';

import {
  constants,
  useWindowSize,
  visuallyHiddenStyles
} from '@newsela/angelou';
import {css} from 'emotion';
import PropTypes from 'prop-types';

import {ReactComponent as SearchIcon} from 'staticImages/icons//globalNavIcons/search.svg';
import {ReactComponent as ChevronDown} from 'staticImages/icons/ChevronDown.svg';

import {
  caretStyle,
  desktopItemStyles,
  itemLabelStyles,
  itemLabelStylesNavRefresh,
  desktopSearchIconStyle,
  mobileStyles
} from './style';

const propTypes = {
  // Pass true to display icon indicating a drop down menu.
  displayChevron: PropTypes.bool,

  // Pass an icon to render which is passed down to the <Icon /> component.
  iconElement: PropTypes.node,

  // Bool indicating whether or not the menu item is the active menu item.
  isActive: PropTypes.bool,

  // Pass a string to render the menu item label.
  itemLabel: PropTypes.string,

  // Pass a boolean to render new global nav styles.
  isNewGlobalNav: PropTypes.bool,
};

export const GlobalNavMenuItem = (props) => {
  GlobalNavMenuItem.displayName = 'GlobalNavMenuItem';
  const {width: windowWidth} = useWindowSize();
  const {
    legacy_breakpoints: {
      Breakpoints: {
        sm,
        xs
      }
    }
  } = constants;

  const {
    displayChevron,
    iconElement,
    isActive,
    isNewGlobalNav,
    itemLabel,
  } = props;

  const visuallyHideLabel = windowWidth < xs ? visuallyHiddenStyles : null;

  const MobileNavItem = () => {
    return (
      <div className={css(mobileStyles)}>
        {iconElement}
        <div className={css(itemLabelStyles(isActive), visuallyHideLabel, isNewGlobalNav ? itemLabelStylesNavRefresh : {})}>
          {itemLabel}
        </div>
      </div>
    );
  };

  const renderDesktopNavItem = () => {
    return (
      <div
        className={css(desktopItemStyles)}
      >
        {itemLabel == 'Search' ?
          <SearchIcon aria-hidden="true" className={css(desktopSearchIconStyle)} />
          :
          null}
        <p className={css(itemLabelStyles(isActive))}>{itemLabel}</p>
        {displayChevron ?
          <ChevronDown aria-hidden="true" className={css(caretStyle(isActive))} />
          :
          null}
      </div>
    );
  };

  return (
    windowWidth > sm ? renderDesktopNavItem() : <MobileNavItem />
  );
};

GlobalNavMenuItem.propTypes = propTypes;
GlobalNavMenuItem.defaultProps = {
  displayChevron: true
};
export default GlobalNavMenuItem;
